import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Stack } from 'syf-component-library/ui/spacing';
import { CenterStackedInset, Content, NoCertificatesFoundContainer } from './subcomponents';
import IMAGE_ASSET_PATHS from '../../../const/assets';
var NoCertificatesFound = function (_a) {
    var config = _a.config;
    var t = useTranslation().t;
    var assets = config.hosts.assets;
    var noCertMessage = t('errorPage.noCertificates').split('\n');
    return (_jsx(NoCertificatesFoundContainer, { children: _jsxs(CenterStackedInset, { children: [_jsx("img", { src: "".concat(assets.origin, "/").concat(IMAGE_ASSET_PATHS.NOT_FOUND), alt: "No Certificates Found" }), _jsx(Stack, { size: "xlarge" }), noCertMessage.map(function (line) { return (_jsx(Content, { children: line })); })] }) }));
};
export default NoCertificatesFound;
